/**
 *  函数防抖：在连续的操作中，无论进行多久时间，只有在最后一次操作结束且经过规定时间没有再操作之后，再执行。
 *  场景： input输入完成之后，一定时间（500ms）没有再输入，则触发函数
 * @param {*} fn
 * @param {*} t
 * @returns
 */
export const Debounce = (fn, t) => {
  let delay = t || 500
  let timer
  return function() {
    let args = arguments
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      fn.apply(this, args)
    }, delay)
  }
}

/**
 * 函数节流：在规定时间内，只执行一次。
 * 场景：按钮，在500ms内，只执行刚开始点击的
 * @param {*} fn
 * @param {*} t
 */
export const Throttle = (fn, t) => {
  let last
  let timer
  let interval = t || 500
  return function() {
    let args = arguments
    let now = +new Date()
    if (last && now - last < interval) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        last = now
        fn.apply(this, args)
      }, interval)
    } else {
      last = now
      fn.apply(this, args)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/debounceThrottle.js